import { z } from 'zod';
/**
 * Phase 2.5 — Eventfile state capture.
 *
 * The dialplan writes state into per-event marker files via `sed -i`.
 * The connector watches these files with chokidar and POSTs each
 * key/old/new diff to the App. The App persists the change history
 * (audit-style) and applies semantic effects (identity confirmation,
 * appointment confirmation, channel delivery flips, DNC propagation).
 */
export const EventStateChangeSchema = z.object({
    key: z.string().min(1).max(128),
    old_value: z.string().max(4096).nullable().optional(),
    new_value: z.string().max(4096),
});
export const PostEventStateRequestSchema = z.object({
    /**
     * The originating place_call command, when known. CallWeaver may
     * continue editing the eventfile after the .call file has been
     * removed (subsequent IVR branches), so this is optional.
     */
    command_id: z.string().min(1).max(128).nullable().optional(),
    /**
     * Wall-clock timestamp of the FS event on the connector side. Used
     * for audit ordering when network roundtrip is slow. Server falls
     * back to now() if absent.
     */
    observed_at: z.string().datetime().optional(),
    changes: z.array(EventStateChangeSchema).min(1).max(64),
});
export const PostEventStateResponseSchema = z.object({
    applied: z.number().int().nonnegative(),
    semantic_effects: z.array(z.string()).default([]),
});
//# sourceMappingURL=event-state.js.map